import { requestService } from "../../services/RequestService";
import { ApiRoutes } from "../../routes/ApiRoutes";
import {WhatsAppUnreadMessageView} from "./view/WhatsAppUnreadMessageView";

export const WhatsAppModelAPI = {
    /**
     * Fetches the list of unread WhatsApp messages for the current operator.
     * @returns {Promise<WhatsAppUnreadMessageView[]>} Promise resolving to an array of unread messages.
     */
    getUnreadMessages: async (): Promise<WhatsAppUnreadMessageView[]> => {
        const response = await requestService.get(ApiRoutes.REST_API_URL_WHATSAPP_UNREAD);
        return response.data.map((item: WhatsAppUnreadMessageView) => new WhatsAppUnreadMessageView(item));
    },

    /**
     * Fetches the count of unread WhatsApp messages for the current operator.
     * @returns {Promise<number>} Promise resolving to the count of unread messages.
     */
    getUnreadCount: async (): Promise<number> => {
        const response = await requestService.get(ApiRoutes.REST_API_URL_WHATSAPP_UNREAD_COUNT);
        return response.data as number;
    },
};
